// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Q8NeG","right":"styles_right__2KYHY"};